module.exports = function() {
  return new Worker("/" + "fa381bb6c3d1669ace55.worker.js");
};